import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import projects from "./../db.json";

const PER_PAGE = 6;

function TechPills({ techs }) {
  if (!techs?.[0]) return null;
  const entries = Object.entries(techs[0]).filter(([,v])=> v).slice(0,6);
  return (
    <div className="tech-row">
      {entries.map(([k, v])=> (
        <span key={k} className="tech-pill">
          {v && v.endsWith('.svg') ? <img src={v} alt={k} /> : null}
          {k}
        </span>
      ))}
    </div>
  )
}

function ProjectCard({ project }) {
  return (
    <Link to={`/projects/${project.id}`} className="project-card">
      <div className="card-media">
        <img src={project.projectMainImg} alt={project.projectName} loading="lazy" />
        {/* <span className="card-badge">#{project.id}</span> */}
      </div>
      <div className="card-body">
        <div className="card-title">{project.projectName}</div>
        <div className="card-desc">{project.projectDescription || project.images?.[0]?.imgDescription || "No description yet — click to explore details."}</div>
        <TechPills techs={project.techs} />
        <div className="card-footer">
          <span className="link-arrow">View details →</span>
          <span style={{fontSize:'0.72rem', color:'#94a3b8', fontWeight:600, maxWidth:'45%', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{project.job ? 'Net Hawks' : project.client || 'Personal'}</span>
        </div>
      </div>
    </Link>
  )
}

export default function Projects() {
    const [page, setPage] = useState(1);
    const [query, setQuery] = useState("");

    const reversedProjects = useMemo(()=> [...projects].sort((a,b)=> b.id - a.id), []);
    const filtered = useMemo(()=>{
      if(!query) return reversedProjects;
      const q = query.toLowerCase();
      return reversedProjects.filter(p => p.projectName.toLowerCase().includes(q) || p.projectDescription?.toLowerCase().includes(q));
    }, [query, reversedProjects]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
    const safePage = Math.min(page, totalPages);
    const start = (safePage - 1) * PER_PAGE;
    const visible = filtered.slice(start, start + PER_PAGE);

    const go = (n) => { setPage(n); window.scrollTo({top:0, behavior:'smooth'}); };

    return (
        <div className="section">
            <div className="section-head" style={{alignItems:'start'}}>
                <div>
                    <div className="eyebrow">Portfolio</div>
                    <h2>All projects</h2>
                    <p>Browse the full archive — paginated, newest first.</p>
                </div>
                <div style={{display:'flex', gap:'10px', alignItems:'center', flexWrap:'wrap'}}>
                  <input
                    value={query}
                    onChange={e=> {setQuery(e.target.value); setPage(1)}}
                    placeholder="Search projects…"
                    style={{padding:'10px 14px', borderRadius:'999px', border:'1px solid #e2e8f0', minWidth:'220px', fontSize:'0.9rem', outline:'none'}}
                  />
                </div>
            </div>

            <div className="projects-grid">
                {visible.map((project) => (
                    <ProjectCard key={project.id} project={project} />
                ))}
            </div>

            {visible.length === 0 && <p style={{textAlign:'center', color:'#64748b', marginTop:'24px'}}>No projects match “{query}”.</p>}

            <div className="pagination">
                <button className="page-btn" disabled={safePage===1} onClick={()=> go(safePage-1)}>‹ Prev</button>
                {Array.from({length: totalPages}, (_,i)=> i+1).map(n=> (
                  <button key={n} className={`page-btn ${n===safePage?'active':''}`} onClick={()=> go(n)}>{n}</button>
                ))}
                <button className="page-btn" disabled={safePage===totalPages} onClick={()=> go(safePage+1)}>Next ›</button>
                <span className="page-info">Page {safePage} / {totalPages}</span>
            </div>

            <div style={{textAlign:'center', marginTop:'10px', color:'#94a3b8', fontSize:'0.82rem'}}>
              Showing {start+1}–{Math.min(start+PER_PAGE, filtered.length)} of {filtered.length} • Tip: homepage previews the latest 3 (IDs 12, 11, 10)
            </div>
        </div>
    )
}
